/** Take in caster and teamCombatants, return a sorted list with caster first or last depending on selfServing value  */
export function getSelfServingTeamOrder(casterModel, teamCombatants) {
  const teamWithoutCaster = teamCombatants.filter(comb => comb.id !== casterModel.id);
  //Return caster first if isSelfServing
  if (casterModel.isSelfServing) {
    return [
      casterModel,
      ...teamWithoutCaster
    ]
  }

  //otherwise, return caster last
  return [
    ...teamWithoutCaster,
    casterModel
  ]
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-sorted-by-self-serving.js